module.exports = "/assets/data/55ac12bfe66acecd760092cd79589587-CV4.data.json";